<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>{{this.pageTitle}} </strong>           
          </div>  
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-card-body>
                <b-row> 
                 <b-col md="5">
                    
                    <b-form-group label="Receipt No"  label-size="sm"
                      :label-cols="5" > 
                       
						<input type="text" id="Receiptno" name="Receiptno" placeholder="Enter Receipt No" class="input form-control input "  v-model="Receiptno"  @keypress="nospace">

                     
                    </b-form-group> 




                     
                 </b-col>
                 <footer class="text-right mr-2" >
                        <b-button type="submit" class="mr-4" size="md" variant="primary"  >Submit</b-button>
                        <b-button type="button" size="md" variant="danger" @click="clear">Clear</b-button>
                    </footer>



                      <b-col md="12">
                    


                  
                    <div  style="margin-top: 40px">
                    <table class="table table-responsive-sm table-bordered table-striped table-sm " border="1">
                        <tr>
                            <td style="width: 51%;">Receipt No  </td>
                            <td style="width: 25%;"> {{items.receipt_no  }} </td>
                        </tr>
                        <tr>
                            <td>Delivery Agent Name </td>
                            <td>{{items.deliveryagentfullname}}</td>
                        </tr>
                        <tr>
                            <td>Amount Deposited </td>
                            <td> {{  items.total}} </td>
                        </tr>
                        <tr>
                            <td>Deposite date </td>
                            <td> {{ items.deposite_date}} </td>
                        </tr>
                    </table>
                  </div>




                     
                 </b-col>
                
               </b-row>
             </b-card-body>
            </form>          
            <b-row>
              <b-col md="12">
                <b-card-body>
                  

                 

              
                 
                </b-card-body>
             </b-col>
            </b-row>            
          </div>
        </b-card>
      </b-col>       
    </b-row>
  </div>
</template>
<style>
.notification.is-success {
      background-color: green!important;
      width: 400px;
}
</style>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
export default {
  data: function() {
    return {
      pageTitle: 'Receipt Tracker',
   
      items:[],
      Receiptno:'',
      // receipt_no:''
    }
  },
  created: function() {
  
   
  },
  methods: {
      clear: function() {
     
        
        this.Receiptno=''; 
        //this.items.receipt_no='';
        this.items.deliveryagentfullname='';
        this.items.total='';
        this.items.deposite_date='';
    },



 nospace : function($event){

      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      
       if (keyCode ==32) {
          $event.preventDefault();
       }
    },

 validateForm(scope) {  

    var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    //console.log(this.Receiptno);
      //console.log('tes:',this.deliveryagentmasteridobj.deliveryagentmasterid);
      this.$validator.validateAll(scope).then(result => {        
        if (result) {
                
               
              
              
                if( this.Receiptno=="" || this.Receiptno==undefined || this.Receiptno==null)  
                {

                  alert("Please insert Receiptno");

                  return false;

                }
                else
                {

         const codinfo = {
        receipt_no:this.Receiptno,
         // hub_id: `${userInfo.pickuplocationmasterid.toString()}`,
         

      }
//console.log(codinfo);
this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdetailsagainstreceiptno`,codinfo)
        .then((result) => {     

          if (result.body.returnmsg === 'Successful' && result.body.returnvalue.length>0) {
         

        

             this.items  = result.body.returnvalue[0];
           
             
          } 

          else 
          {
            this.items=[];
          
          }
        
        }).catch((ex) => {
          console.log('error-----', ex)
        })

                }
                

          
        } 
      })
    }



},




	

    }
  


</script>

